module.exports = __webpack_public_path__ + "img/Zugführer.303f34be.svg";